import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import useDetailStyles from '../detail-styles'
import DownloadPlanHeaderAction from './download-plan-header-action'
import { downloadActivity } from '../lib/plan-download'
import useRegisterActivityPlanDetailHeader from '../hooks/use-register-activity-plan-detail-header'
import ActivityDetailContent from './activity-detail-content'

const ActivityDetailView = ({ hit }) => {
  const classes = useDetailStyles()

  const setupDuration = hit.details?.setupDuration
  const durationMins = hit.details?.durationMins
  const subtitle = [
    setupDuration != null ? `Setup ${setupDuration} min` : null,
    durationMins != null ? `Duration ${durationMins} min` : null,
  ]
    .filter(Boolean)
    .join(' · ')

  const { HeaderActionsPortal } = useRegisterActivityPlanDetailHeader({
    title: hit.title,
    subtitle,
  })

  return (
    <>
      <HeaderActionsPortal>
        <DownloadPlanHeaderAction
          buttonLabel="Download Activity"
          dialogTitle="Download activity"
          dialogDescription="Download this activity as a text file. Click Download to save it to your device."
          onDownload={() => downloadActivity(hit)}
        />
      </HeaderActionsPortal>
      <Box className={classes.contentContainer}>
        <ActivityDetailContent hit={hit} />
      </Box>
    </>
  )
}

ActivityDetailView.propTypes = {
  hit: PropTypes.object.isRequired,
}

export default ActivityDetailView
